import { SET } from './mutation-types'
export const newContactDialog = {
  namespaced: true,
  state: {
    visible: false
  },
  actions: {
    set ({ commit }, val) {
      commit(SET, val)
    }
  },
  mutations: {
    [SET] (state, val) {
      state.visible = val
    }
  }
}
